import { CURRENT_CLIENT } from '@/constants/index'

export function linkedinShareEnabled(): boolean {
  const features = (CURRENT_CLIENT as { features?: { linkedinShare?: { enabled?: boolean } } }).features
  return Boolean(features?.linkedinShare?.enabled)
}

export function buildLinkedInShareOffsiteUrl(jobUrl: string): string {
  const url = jobUrl.trim()
  if (!url) return ''
  return `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(url)}`
}
